import { ArrowUpRight } from "lucide-react";

export default function ServiceCard({
  number,
  title,
  description,
  tags,
  icon,
}) {
  return (
    <div className="group  p-7 border border-gray-50   transition-all duration-300 hover:bg-gray-50 ">
      {/* Top */}

      <div className="mb-6 flex items-center justify-between">
        <div className="flex h-11 w-11 items-center justify-center rounded-full border border-[#d9bc6d] text-[#d9bc6d]">
          {icon}
        </div>

        <span className="text-xs text-gray-400">#{number}</span>
      </div>

      <h3 className="mb-4 font-semibold text-2xl leading-snug text-[#13254d] transition group-hover:text-[#d9bc6d]">
        {title}
      </h3>

      <p className="mb-6 text-sm leading-7 text-gray-500">{description}</p>

      <div className="flex flex-wrap gap-2">
        {tags.map((tag) => (
          <span
            key={tag}
            className="bg-[#f8f0d8] px-2 py-1 text-[10px] font-semibold uppercase tracking-wide text-[#7b5b12]"
          >
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
}
